module.exports = __webpack_public_path__ + "img/foto-perfil-dados.7142c215.png";